
/**
 * Punkt 11 der Vorankuendigung: besonders gefaehrliche Arbeiten nach Anhang II
 * BaustellV (Fassung ab 01.04.2023).
 *
 * Gespeichert wird in `vorankuendigung.selectedDangerousWorks` die `id`, NICHT
 * das Label. Die Ids sind deshalb unveraenderlich — jede gespeicherte
 * Vorankuendigung haengt daran. Wer eine Nummer neu zuschneidet, legt eine neue
 * Id an und laesst die alte stehen.
 *
 * Die Labels folgen dem Wortlaut der Planungsphase
 * (`components/planungsphase/fragenkatalog.ts`, ANHANG_2_ARBEITEN). Sie landen
 * ueber `dangerousWorkDescription` im PDF — jsPDF kann nur CP1252, also keine
 * Zeichen ausserhalb davon. Welche Id zu welcher Anhang-II-Nummer, welchem
 * Handbuch-Wortlaut und welchem Planungsmerkmal gehoert, steht in
 * `anhang2Bruecke.ts`.
 *
 * Reihenfolge = Nummer im Anhang II. Kein Code haengt an der Position, nur an
 * der Id (`FormEditor.tsx` sucht per `find`).
 */
export const DANGEROUS_WORKS = [
  // Nr. 1 — in der Vorankuendigung auf zwei Ids verteilt
  { id: "versinken", label: "Arbeiten mit Gefahr des Versinkens oder Verschüttetwerdens in Baugruben oder Gräben über 5 m Tiefe" },
  { id: "absturz", label: "Arbeiten mit Absturzgefahr aus mehr als 7 m Höhe" },
  // Nr. 2 — die Stoffliste ist auf zwei Altbestands-Ids verteilt
  { id: "explosiv", label: "Arbeiten mit explosiven, entzündbaren oder akut toxischen Stoffen und Gemischen" },
  { id: "chemisch", label: "Arbeiten mit karzinogenen, keimzellmutagenen oder reproduktionstoxischen Stoffen und Gemischen (Kat. 1A/1B) oder biologischen Arbeitsstoffen der Risikogruppe 3 oder 4" },
  // Nr. 3
  { id: "strahlung", label: "Arbeiten mit ionisierender Strahlung (Kontroll- oder Überwachungsbereich nach Strahlenschutzrecht)" },
  // Nr. 4
  { id: "hochspannung", label: "Arbeiten in geringerem Abstand als 5 m von Hochspannungsleitungen" },
  // Nr. 5
  { id: "ertrinken", label: "Arbeiten mit unmittelbarer Gefahr des Ertrinkens" },
  // Nr. 6
  { id: "untertage", label: "Brunnenbau, unterirdische Erdarbeiten, Tunnelbau" },
  // Nr. 7 — fehlte bisher
  { id: "tauchen", label: "Arbeiten mit Tauchgeräten" },
  // Nr. 8
  { id: "druckluft", label: "Arbeiten in Druckluft" },
  // Nr. 9 — fehlte bisher; war in „explosiv" (Nr. 2) mitgemeint
  { id: "sprengen", label: "Arbeiten mit Sprengstoff oder Sprengschnüren" },
  // Nr. 10 — seit 01.04.2023 ohne 10-t-Grenze
  { id: "schwere_bauteile", label: "Auf- und Abbau von Massivbauelementen mit kraftbetriebenen Maschinen oder Versetzgeräten" },
] as const;

export const PROJECT_TYPES = [
  "Neubau eines Wohngebäudes",
  "Neubau eines Bürokomplexes",
  "Sanierung und Umbau",
  "Abbruch eines Industriegebäudes",
  "Errichtung einer Industriehalle",
  "Straßenbauarbeiten",
  "Tiefbau und Kanalisation",
  "Dachsanierung",
  "Fassadensanierung"
];

export const COORDINATOR_COMPANIES = [
  { id: "own", label: "Eigene Firma", address: "" },
  { id: "client", label: "Bauherr", address: "" }
];

export const COORDINATOR_PEOPLE = [
  { id: "coord", label: "Koordinator", details: "" },
  { id: "deputy", label: "Stellvertreter", details: "" }
];
